import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, FormGroup, Label, Card, Col } from "reactstrap";
import { useForm } from "react-hook-form";
import ApiService from "../../../services/apiService";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { updateDistributaryTitle, distributaryZone } from "../../../constants";
import Update from "../../table/Update";

const UpdateBeneficiary =() =>{
    
    const navigate = useNavigate();
    const { Id } = useParams();
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [data,setData] = useState<any>();
    const [chackData, setChackData] = useState<any>(null);
    const [distributaryData,setDistributaryData] = useState<any>(null);
    const [schemeVillageData,setSchemeVillageData] = useState<any>(null);
    const [wuaData,setWuaData] = useState<any>([])
    


    const initialData ={

        
        ChakName:data?.chakName,
        CcaAcre:data?.ccaAcre,
        NameOfBeneficiary:data?.nameOfBeneficiary,
        Plot_No:data?.plot_No
       
    }

   


    useEffect(()=>{
      const distributaryData = async ( )=>{
          try{
                const response = await ApiService.axiosApi(`/dzone`,{
                  method:"GET",
                  params:{
                    pageNumber :0,
                    pageSize:0
               }
                })
                if(response.success){
                  setDistributaryData(response.data.data);
                }
            }catch(error:any){
              toast.error(error.message|| "Failed to fetch Distributary Data");
            }
      }

      const fecthWua = async()=>{
        try{
            const response = await ApiService.axiosApi(`/wua`,{
                method:'GET'
            });
            if(response.success){
                setWuaData(response.data)
            }
        }catch(error:any){
           toast.error(error.message || "Failed to fetch Scheme Village");
       }
   }
   
   fecthWua();
      distributaryData();
  },[])

  useEffect(()=>{
      const schemeVillage = async()=>{
          try{
              const response = await ApiService.axiosApi(`/schemevillage`,{
                  method:"GET",
                  params:{
                    pageNumber :0,
                    pageSize:0
               }
              })
              if(response.success){
                  setSchemeVillageData(response.data.data);
              }
          }catch(error:any){
              toast.error(error.message|| "Failed to fetch Scheme Village");
          }
      }
      schemeVillage();
  },[])

    useEffect(() => {



          


        const fetchBeneficiary = async () => {
          try {
            const response = await ApiService.axiosApi(`/beneficiarylist/${Id}`, {
              method: 'GET',
            });
    
            if (response.success) {
                console.log(response.data)
              setData(response.data)
            } else {
              toast.error("Failed to fetch distributary details");
              navigate(-1);
            }
          } catch (error: any) {
            toast.error(error.message || "Failed to fetch distributary details");
            navigate(-1);
          }
        };
    
        if (Id) fetchBeneficiary();
      }, [Id, setValue, navigate]);

      useEffect(() => {

        const chack = async () => {
            try {
                const response = await ApiService.axiosApi(`/chack`, {
                    method: "GET",
                    params: {
                        pageNumber: 0,
                        pageSize: 0
                    }
                })
                if (response.success) {
                    
                    setChackData(response.data.data)

                } else {
                    toast.error(response.message || "Failed to fetch chack data");
                }
            } catch (error: any) {
                toast.error(error.message || "Failed to fetch chack data");
            }
        }
        chack();
    }, [])
    
      const onSubmit = async (data: any) => {
        try {
          const updateData = {
            ChakId: data.chakId,
            CcaAcre:data.CcaAcre,
            NameOfBeneficiary:data.NameOfBeneficiary,
            SchemeVillageId:data.SchemeVillageId,
            DistributaryZoneId:data.DistributaryZoneId,
            WuaId:data.Wua_Id,
            Plot_No:data.Plot_No
            

          };
    
            const response = await ApiService.axiosApi(`/beneficiarylist/${Id}`, {
            method: 'PUT',
            data: updateData
          });
    
          if (response.success) {
            toast.success("beneficiary updated successfully");
            navigate(-1);
          } else {
            toast.error(response.data.message || "Failed to update beneficiary");
          }
        } catch (error: any) {
          toast.error(error.message || "Failed to update beneficiary");
        }
      };

      return(

          
             <Update
       title = {'Update Beneficiary '}
       parentTitle={'Beneficiary List'}
       
       fields ={
        [
          
          {
            name:"NameOfBeneficiary",
            label:"Name Of Beneficiary",
            type:"text"
         },
          
          {
             name:"CcaAcre",
             label:"C.C.A Acre",
             type:"text"
          },
         
          {
            name:"Plot_No",
             label:"Plot",
             type:"text"
           },
        {
          name: "ChakName",
          label: "Chak",
          isDropdown: true,
          dropdownData: chackData,
          dropdownLabel: "chackName",
          idFieldName: "chakId"

      }


        ]
       }
       onSubmit = {onSubmit}
       initialData = {initialData}
       />
          
      )
    
}
export default UpdateBeneficiary;